import {LayoutWrapperDefaultBox} from "./layout-wrapper.default.box";

export const LayoutWrapperBox = LayoutWrapperDefaultBox;